import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class name merger — combines clsx (conditional) + tailwind-merge (deduplication).
 * Use in every component: `className={cn('base', condition && 'extra', className)}`
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
